import React from "react";
import { Modal, Button } from "react-bootstrap";

interface ImagePreviewModalProps {
  show: boolean;
  onHide: () => void;
  imageUrl?: string | null;
  title?: string;
  body?: any
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  show,
  onHide,
  imageUrl,
  title = "Image Preview",
  body
}) => {
  const handleDownload = () => {
    if (imageUrl) {
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "downloaded-image.jpg";
      link.click();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Preview"
            style={{ maxWidth: "100%", borderRadius: "10px" }}
          />
        ) : (
          body
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleDownload}>
          Download
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImagePreviewModal;
